import { format, startOfWeek, endOfWeek, eachDayOfInterval, isSameDay } from 'date-fns';

export interface WeekDay {
  date: Date;
  dateString: string;
  dayName: string;
  dayShort: string;
  isToday: boolean;
  isWeekend: boolean;
}

export const getWeekDays = (weekDate: Date): WeekDay[] => {
  const weekStart = startOfWeek(weekDate, { weekStartsOn: 1 }); // Monday start
  const weekEnd = endOfWeek(weekDate, { weekStartsOn: 1 });
  const today = new Date();
  
  const days = eachDayOfInterval({ start: weekStart, end: weekEnd });
  
  return days.map(date => ({
    date,
    dateString: format(date, 'yyyy-MM-dd'),
    dayName: format(date, 'EEEE'),
    dayShort: format(date, 'EEE'),
    isToday: isSameDay(date, today),
    isWeekend: date.getDay() === 0 || date.getDay() === 6
  }));
};

export const getCurrentWeekStart = (): Date => {
  return startOfWeek(new Date(), { weekStartsOn: 1 });
};

export const formatWeekRange = (weekDate: Date): string => {
  const weekStart = startOfWeek(weekDate, { weekStartsOn: 1 });
  const weekEnd = endOfWeek(weekDate, { weekStartsOn: 1 });
  return `${format(weekStart, 'MMM d')} - ${format(weekEnd, 'MMM d, yyyy')}`;
};